import _ from './Manager'

class Page{

    constructor(){
        _.events.on( 'hide', this.onPageHide, this )
        _.events.on( 'show', this.onPageShow, this )
        _.events.on( 'unload', this.onPageUnload, this )
    }

    onPageHide(){ console.log(`Hidding ${this.id}...`) } // si ponemos un método que defina una subclase se llamará al metodo de la subclase en lugar de este.
    onPageShow(){ console.log(`Showing ${this.id}...`) }
    onPageUnload(){ console.log(`Unloading ${this.id}...`) }


}

export default Page